import React from 'react';
import PropTypes from 'prop-types';
import {InputSlider} from '../InputSlider';
/**
 * Slider Component:
 *  - Slider to control the animation
 */
export function Slider(props) {
  const renderSliderLabel = (className, label) => (
    <span className={className} dangerouslySetInnerHTML={{__html: label}} />
  );

  return (
    <div className={props.className}>
      <h5 className={`${props.className}_text`}>{props.text}</h5>
      <InputSlider
        value={props.current.value}
        min={props.limits.min.value}
        max={props.limits.max.value}
        onChange={props.onChange}
        className={`${props.className}_input`}
      />
      <div className={`${props.className}_label`}>
        {renderSliderLabel(
          `${props.className}_label_min`,
          props.limits.min.label
        )}
        {renderSliderLabel(
          `${props.className}_label_max`,
          props.limits.max.label
        )}
      </div>
    </div>
  );
}

Slider.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * text to display on top of slider
   */
  text: PropTypes.string,
  /**
   * The max and min values to display on slider
   */
  limits: PropTypes.shape({
    /**
     * Data for point minimum
     */
    min: PropTypes.shape({
      /**
       * Value for the point
       */
      value: PropTypes.number,
      /**
       * Label for the point
       */
      label: PropTypes.string,
    }),
    /**
     * Data for point maximum
     */
    max: PropTypes.shape({
      /**
       * Value for the point
       */
      value: PropTypes.number,
      /**
       * Label for the point
       */
      label: PropTypes.string,
    }),
  }),
  /**
   * The current status of the slide
   */
  current: PropTypes.shape({
    /**
     * Value for the point
     */
    value: PropTypes.number,
    /**
     * Label for the point
     */
    label: PropTypes.string,
  }),
  /**
   * Function to invoke on slider value change
   */
  onChange: PropTypes.func,
};

Slider.defaultProps = {};
